import React from 'react'
import { Button, Modal } from 'antd'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import { useFinishRefinementMutation } from '../../../../../../../store/apis/rubric-refinement.api'
import { buildAssignmentPath } from '../../../../../../../utils/link.helper'
import { useVersionId } from '../../../../../../../utils/parseURL.helper'
import { AssignmentSections } from '../../../../../../../constants/assignment-sections'
import { CheckOutlined } from '@ant-design/icons'
import { successColor } from '../../../../../../../constants/styles'

const FinishRefinementButton = props => {
    const navigate = useNavigate()
    const refinementProcess = useSelector(rubricRefinementSelectors.refinementProcess)
    const refinementProgress = useSelector(rubricRefinementSelectors.refinementProgress)
    const [finishRefinement, { isLoading: isFinishingRefinement }] = useFinishRefinementMutation()
    const { token, layerId } = useParams()
    const versionId = useVersionId()

    const { hasApprovedSuggestions, isAllItemsReviewed, ...buttonProps } = props

    const handleFinish = async () => {
        if (!hasApprovedSuggestions) {
            navigate(buildAssignmentPath(token, layerId, AssignmentSections.HOME, versionId))
            return
        }

        Modal.confirm({
            title: 'Apply Refinements to Rubric?',
            icon: null,
            content: `This will update your grading rubric with all accepted refinements. You can return to continue refining additional items at any time.`,
            okText: 'Apply',
            okType: 'primary',
            onOk: async () => {
                if (refinementProcess?.id) {
                    try {
                        await finishRefinement({id: refinementProcess.id, token, versionId}).unwrap()
                        navigate(buildAssignmentPath(token, layerId, AssignmentSections.HOME, versionId))
                    } catch (error) {
                        console.error('Error applying refinements:', error)
                    }
                }
            }
        })
    }

    const hasReviewedItems = refinementProgress?.itemsReviewed > 0

    const buttonText = hasApprovedSuggestions ? 'Apply Refinements' : 'OK'
    const isEnabled = hasReviewedItems && (hasApprovedSuggestions || isAllItemsReviewed)

    return (
        <Button 
            onClick={handleFinish}
            loading={isFinishingRefinement}
            icon={<CheckOutlined />}
            style={{ color: props.type === 'primary' || !isEnabled ? undefined : successColor }}
            disabled={!isEnabled}
            {...buttonProps}
        >
            {buttonText}
        </Button>
    )
}

export default FinishRefinementButton 